namespace $.$$ {
	$mol_style_define($easyreels_user_recording, {
		flex: {
			direction: 'column',
		},
		gap: $mol_gap.block,
	})
}
